import React, { useState,useEffect } from 'react';
import '../components-css/templates.scss';

const TemplateShowcase = () => {
    const [activeTab, setActiveTab] = useState('mail'); // 'mail', 'whatsapp', 'inquiry'
    const [copiedId, setCopiedId] = useState(null);
    const [authChecked, setAuthChecked] = useState(false);

    const handleCopyTemplate = (content, id) => {
        navigator.clipboard.writeText(content);
        setCopiedId(id);
        setTimeout(() => setCopiedId(null), 2000); // Reset after 2 seconds
    };
    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem('authToken');

            if (!token) {
                window.location.href = '/sales-sop/templates';
                return;
            }

            fetch('https://newomkatech.omkatech.in/api/check-token', {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.valid === true) {
                        setAuthChecked(true); // ✅ Valid
                    } else {
                        localStorage.removeItem('authToken');
                        window.location.href = '/sales-sop/templates';
                    }
                })
                .catch(() => {
                    localStorage.removeItem('authToken');
                    window.location.href = '/sales-sop/templates';
                });
        };

        // ✅ Run immediately on mount
        checkAuth();

        // 🔄 Then re-check every 20 minutes
        const interval = setInterval(checkAuth, 1 * 60 * 1000);

        // 🧹 Cleanup on unmount
        return () => clearInterval(interval);
    }, []);
    const mailTemplates = [
        {
            id: 1,
            title: "Sample 1 – Initial / 1st–2nd Follow-up",
            content: `Hi John, how are you doing?
  
  I'm following up on my previous email regarding the development of a website for your business.
  
  Kindly share a brief overview of your business requirements so I can better understand them and share my understanding with you. This will help ensure we are aligned before moving forward.
  
  You may also book a convenient time for a quick call using my calendar:
  https://calendly.com/riyaomka
  
  Looking forward to hearing from you.`
        },
        {
            id: 2,
            title: "Sample 2 – 1st–2nd Follow-up",
            content: `Hi John, I hope my email finds you well!

Just wondering if you got time to review my email about the website development/redesign for your business.

Can we get on a quick call to discuss your business needs and take our discussion forward from there?

I look forward to your reply!`
        },
        {
            id: 3,
            title: "Sample 3 – 1st–2nd Follow-up",
            content: `Hi John, how have you been?

Just curious to know if you received my last email.

Kindly acknowledge the receipt. I look forward to hearing an update on the same.`
        },
        {
            id: 4,
            title: "Sample 4 – Monday Follow-up (After Weekend)",
            content: `Hi John, I hope you had a nice weekend!

Just checking if you got time to review my email regarding the App for your business.

How about a quick chat to discuss your requirements along with our working process and fees?

Kindly let me know, I look forward to your reply!`
        },
        {
            id: 5,
            title: "Sample 5 – 3rd–4th Follow-up",
            content: `Hi John, 
            did you receive my last email and have time to review it?

Kindly acknowledge the receipt of the same so I can be sure that my email has reached your inbox.

I look forward to hearing from you.`
        },
        {
            id: 6,
            title: "Sample 6 – After 2+ Weeks of No Response",
            content: `Hi John, how have you been?

It's been a while since I've tried to reach out to you regarding your inquiry for the Website Development.

Do you still need it, or are there any changes in the plan?

Kindly let me know so I can move forward accordingly.`
        },
        {
            id: 7,
            title: "Sample 7 – After Multiple Follow-ups",
            content: `Hi John, please consider this as a follow-up to my email sent last week about the website for your business

Do you have any updates for me?

I look forward to hearing from you.`
        },
        {
            id: 8,
            title: "Sample 8 – SEO Audit Follow-up",
            content: `Hi John, how are you doing?

I'm checking in if you got time to review the Website Audit report that I shared in my last email.`
        },
        {
            id: 9,
            title: "Sample 9 – Old Lead Re-engagement",
            content: `Hi Les, how have you been?

This is Riya. We got in touch a couple of months ago about website development for your business.

I tried sending you multiple emails, but I'm not sure if they reached you.

Please let me know if you still have those requirements for your business or if plans have changed.

Kindly provide me with clarity, so I can move forward accordingly.

I'm waiting for your reply!
`
        },
        {
            id: 10,
            title: "Sample 10 – Quick Confirmation",
            content: `Hi John, did you receive my email I sent yesterday?

Kindly let me know if we can have a quick chat to discuss your business requirements and take it from there.

I look forward to hearing from you.`
        },
        {
            id: 11,
            title: "Sample 11 – Short Nudge",
            content: `Hi John, were you able to look at my previous email?

            I look forward to hearing from you.`
        },
        {
            id: 12,
            title: "Sample 12 – Website Inquiry Closure Check",
            content: `Hi John, hope you are doing well.

You connected with us regarding your inquiry for website development/redesign.

I'm just checking in to see if you are still looking for it. Please let me know so I can assist you further.

Also, if you have changed your mind, do let me know so I can stop bothering you.

Looking forward to your response.`
        },
        {
            id: 13,
            title: "Sample 13 – Mobile App Inquiry Closure",
            content: `Hi John, hope you are well.

You inquired with us about a mobile app for your business.

Do you still have those requirements, or have you changed your mind?

Please let me know so we can reconnect to discuss further, or I can take you off the list.

Looking forward to hearing from you.`
        },
        // {
        //     id: 14,
        //     title: "Sample 14 – SEO Services Introduction",
        //     content: `Hi John, thanks for reaching out.
        
        // I’m Riya Tillashi, writing on behalf of Asim from Omka Tech.
        
        // We help businesses improve search visibility, rankings, and qualified inbound traffic through a structured, end-to-end SEO process.
        
        // In addition to traditional search engines, we also work on visibility across AI-driven search platforms to ensure your business is discoverable where users are increasingly searching.
        
        // Our approach is built for long-term outcomes, not short-term spikes.
        
        // That focus is why several of our clients have continued working with us for three to four years on the same businesses, which is uncommon in this space.
        
        // SEO pricing depends on scope. As a reference point, a package covering up to 30 keywords is priced at approximately USD 300 per month.
        
        // This includes:
        // • A dedicated SEO specialist working on your account  
        // • A project manager responsible for coordination, weekly progress reports, and updates  
        // • Ongoing optimization, monitoring, and performance analysis  
        
        // How about a quick call to understand your business model, target audience, and growth goals so the scope is aligned with what you actually need?
        
        // Looking forward to your response.`
        // }     
    ];


    const initialInquiryTemplates = [
        {
            id: 1,
            title: "Sample 1",
            inquiry: (
                <>
                    <strong>Client 1 -</strong> <br /><br />
                    Please go ahead and send the information. <br /> <br />
                </>
            ),
            content: (
                <>
                    <strong>Omka -</strong> <br /><br />
                    Hi Robert, thanks for your email!
                    <br /><br />
                    I'm Riya Tillashi and I'm getting back to you on behalf of Soniya from Omka Tech.
                    <br /><br />
                    I have reviewed your website personally, it definitely fulfils the purpose of the website but seems quite old.
                    <br /><br />
                    We proposed you to get it re-designed where we will make it look attractive and more professional. We will design it in a user-friendly manner for the customers to easily scroll the business information.
                    <br /><br />
                    Also, do you have any pain-points or suggestions which you plan to get done in the new website so we can take care of it.
                    <br /><br />
                    How about a quick call to discuss this in more detail and take it from there?
                    <br /><br />
                    I look forward to hearing from you.
                </>
            )
        },

        {
            id: 2,
            title: "Sample 2",
            inquiry: (
                <>
                    <strong>Client 2 -</strong> <br /><br />
                    Thank you for your email. Please send me your proposal. <br /> <br />
                </>
            ),
            content: (
                <>
                    <strong>Omka -</strong> <br /><br />
                    Hi Meysam, thanks for your email!
                    <br /><br />
                    I'm Riya Tillashi and I'm getting back to you on behalf of Dentik from Omka Tech.
                    <br /><br />
                    We reached out to you offering our services of tailor-made websites for your business.
                    <br /><br />
                    Do you have such requirements? Please let me know. We do have multiple offers going on which can help you get a great deal.
                    <br /><br />
                    I look forward to hearing from you.
                </>
            )
        },

        {
            id: 3,
            title: "Sample 3",
            inquiry: (
                <>
                    <strong>Client 3 -</strong> <br /><br />
                    Sure, please send the details. <br /> <br />
                </>
            ),
            content: (
                <>
                    <strong>Omka -</strong> <br /><br />
                    Hi Michael, thanks for your email!
                    <br /><br />
                    I'm Riya Tillashi and I'm responding on behalf of Dlirer from Omka Tech.
                    <br /><br />
                    We are an ISO-Certified company with a team of 55+ professionals having our Sales Office in Dallas, TX.
                    <br /><br />
                    You can review our website at www.omkatech.com
                    <br /><br />
                    We expertise in bespoke solutions where we design and develop websites from scratch as per the business requirements.
                    <br /><br />
                    May I know what exactly you need for your business so I can understand and provide you with the best way to move forward?
                    <br /><br />
                    Or, we can get on a quick call to discuss it in detail and proceed further from there.
                    <br /><br />
                    Looking forward to hearing from you.
                </>
            )
        },

        {
            id: 4,
            title: "Sample 4",
            inquiry: (
                <>
                    <strong>Client 4 -</strong> <br /><br />
                    Send me the price list and samples please. <br /> <br />
                </>
            ),
            content: (
                <>
                    <strong>Omka -</strong> <br /><br />
                    Hi Lennie, thanks for showing interest in our web development services.
                    <br /><br />
                    Myself Riya Tillashi and I'm getting back to you on behalf of Ankita from Omka Tech.
                    <br /><br />
                    We have expertise in custom Website Development so our development fees depends upon the type of website you need.
                    <br /><br />
                    Please share a brief of what you need so I can understand and provide you with the best-suited and preferable way to proceed further.
                    <br /><br />
                    Below-mentioned are a few of our developed websites:
                    <br /><br />
                    - Expansive
                    <br /><br />
                    - Anakiki
                    <br /><br />
                    - Bomens
                    <br /><br />
                    Kindly have a look, it would help you get an idea about our technical capabilities.
                    <br /><br />
                    Or, we can get on a quick call to discuss it in detail and proceed from there.
                    <br /><br />
                    I look forward to hearing from you.

                </>
            )
        },

        {
            id: 5,
            title: "Sample 5",
            inquiry: (
                <>
                    <strong>Client 5 -</strong> <br /><br />
                    Please forward the price list <br /> <br />
                </>
            ),
            content: (
                <>
                    <strong>Omka -</strong> <br /><br />
                    Hi Reginald, thanks for showing interest in our services.
                    <br /><br />
                    I'm Riya Tillashi and I'm getting back to you on behalf of Glotik from Omka Tech.
                    <br /><br />
                    We have expertise in bespoke development where we design and develop websites based on the business requirements.
                    <br /><br />
                    So, our development fee depends upon the type of website requirements you have for your business.
                    <br /><br />
                    To give you an idea, our hourly rate generally comes around as low as $6 - $8 depending upon the scope of work and its complexity.
                    <br /><br />
                    It would be great if you could share a brief of your business requirements for us to understand and provide with our development charges.
                    <br /><br />
                    Or, we can set a video meeting at your earliest convenience to discuss and move forward.
                    <br /><br />
                    I look forward to hearing from you.
                </>
            )
        },

        {
            id: 6,
            title: "Sample 6",
            inquiry: (
                <>
                    <strong>Client 6 -</strong><br /><br />
                    Please share demo. <br /> <br />
                </>
            ),
            content: (
                <>
                    <strong>Omka -</strong> <br /><br />
                    Hi, thanks for your email!
                    <br /><br />
                    Myself Riya Tillashi and I'm getting back to you on behalf of Subodh from Omka Tech.
                    <br /><br />
                    We do tailor-made solutions where we design and develop them from scratch as per the business requirements.
                    <br /><br />
                    So, there is no ready demo, but we can develop website or mobile app for your business as per the requirements.
                    <br /><br />
                    You can review our website at www.omkatech.com to get an idea about our work capabilities.
                    <br /><br />
                    Could you please share a brief of what you need so I can understand and assist you further?
                    <br /><br />
                    Or, we can jump over a quick call at your earliest convenience to discuss your business requirements in detail and proceed further from there.
                    <br /><br />
                    I look forward to hearing from you.
                </>
            )
        },

        {
            id: 7,
            title: "Sample 7",
            inquiry: (
                <>
                    <strong>Client 7 -</strong> <br /><br />
                    What do you offer? <br /> <br />
                </>
            ),
            content: (
                <>
                    <strong>Omka -</strong> <br /><br />
                    Hi, thanks for your email!
                    <br /><br />
                    Myself Riya Tillashi and I'm getting back to you on behalf of my colleague, Katalina from Omka Tech.
                    <br /><br />
                    We reached out to you offering our Website Development Services where we can help you get a professional and user-friendly website.
                    <br /><br />
                    May I know your business needs so I can understand and provide you with the best-suited and preferable way to proceed further?
                    <br /><br />
                    Or, we can also jump on a quick call to discuss it in detail and take it from there.
                    <br /><br />
                    I look forward to hearing from you.
                </>
            )
        },

        {
            id: 8,
            title: "Sample 7",
            inquiry: (
                <>
                    <strong>Client 7 -</strong> <br /><br />
                    Hi John, I hope you are doing well! <br /> <br />
                </>
            ),
            content: (
                <>
                    I’m Riya from Omka Tech. We received your inquiry on email regarding the App Development for your business.
                    <br /><br />
                    I have replied to your email with all the required information.
                    <br /><br />
                    I just wanted to check in if you received it.
                    <br /><br />
                    Kindly let me know, I would be happy to set a quick call to discuss about business requirements.
                    <br /><br />
                    <div>
                    <p>Regards</p>
                    <p>Riya</p>
                    <p>riya@omkatech.com</p>
                    </div>
                </>
            )
        }
    ];

    return (
        <div className="container">
            <div className="main-wrapper">
                {/* Header */}
                <div className="template-top-header">
                    <h1 className="main-title">
                        Initial Inquiry & Follow-Up Templates
                    </h1>
                    <p className="subtitle">
                        A structured set of templates for managing customer inquiries and follow-ups. Supports timely responses at every stage of the sales process. Improves coordination and accountability within the sales team.
                    </p>

                    {/* Navigation Tabs */}
                    <div className="nav-tabs">
                        <button
                            className={`nav-btn ${activeTab === 'mail' ? 'nav-btn-active' : ''}`}
                            onClick={() => setActiveTab('mail')}
                        >
                            Mail Follow-up Templates
                        </button>
                        <button
                            className={`nav-btn ${activeTab === 'whatsapp' ? 'nav-btn-active' : ''}`}
                            onClick={() => setActiveTab('whatsapp')}
                        >
                            WhatsApp Follow up Templates
                        </button>
                        <button
                            className={`nav-btn ${activeTab === 'inquiry' ? 'nav-btn-active' : ''}`}
                            onClick={() => setActiveTab('inquiry')}
                        >
                            Initial Inquiry Templates
                        </button>
                    </div>
                </div>

                {/* Mail Follow-up Templates View */}
                {activeTab === 'mail' && (
                    <div className="single-column-view">
                        <div className="warning-box">
                            <p className="warning-text">
                                ⚡ Modify templates using your understanding and client situation
                            </p>
                        </div>

                        <h2 className="page-title">
                            Mail Follow up Templates (Send on 3rd day or 4th day)
                        </h2>

                        <div className="two-column-grid">
                            {mailTemplates.map((template) => (
                                <div
                                    key={template.id}
                                    className="template-card-large"
                                >
                                    <div className="template-header">
                                        <h3 className="template-title-large">
                                            {template.title}
                                        </h3>
                                        <button
                                            onClick={() => handleCopyTemplate(template.content, `mail-${template.id}`)}
                                            className="copy-btn-small"
                                            title="Copy template"
                                        >
                                            {copiedId === `mail-${template.id}` ? '✓ Copied' : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>}
                                        </button>
                                    </div>
                                    <p className="template-content-large">
                                        {template.content}
                                    </p>
                                </div>
                            ))}
                        </div>

                        <hr />

                        <div className="bottom-sections">

                            {/* SECTION 1 */}
                            <div className="bottom-section">
                                <button
                                    className="copy-btn-bottom"
                                    onClick={() => {
                                        navigator.clipboard.writeText(`Hi John, how are you? How is your business doing?

Myself Riya Tillashi from Omka Tech.
You reached out to us a couple of months back inquiring about our digital marketing services to
increase your website visibility and get more customers on it.

Unfortunately, we couldn't connect then so I'm reaching out again to see if you still have such
requirements.

Along with SEO to get higher ranking on Google, we are also offering GEO which will help your
business get visibility on all the major AI players like ChatGPT, Gemini, Gemini, Grok, etc.

Would you be interested in discussing this further?
Please let me know, I look forward to hearing from you`);

                                        setCopiedId("email-1");
                                        setTimeout(() => setCopiedId(null), 2000);
                                    }}
                                >
                                    {copiedId === "email-1" ? "✓ Copied" : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>}
                                </button>

                                <h3 className="bottom-title">
                                    To send to leads as a fresh email after 2–3 months – Only marketing
                                </h3>

                                <p className="bottom-text">
                                    Hi John, how are you? How is your business doing? <br /><br />
                                    Myself Riya Tillashi from Omka Tech.
                                    You reached out to us a couple of months back inquiring about our digital marketing services to
                                    increase your website visibility and get more customers on it. <br /><br />
                                    Unfortunately, we couldn't connect then so I'm reaching out again to see if you still have such
                                    requirements. <br /><br />
                                    Along with SEO to get higher ranking on Google, we are also offering GEO which will help your
                                    business get visibility on all the major AI players like ChatGPT, Gemini, Grok, etc. <br /><br />
                                    Would you be interested in discussing this further?
                                    Please let me know, I look forward to hearing from you
                                </p>
                            </div>

                            {/* SECTION 2 */}
                            <div className="bottom-section">
                                <button
                                    className="copy-btn-bottom"
                                    onClick={() => {
                                        navigator.clipboard.writeText(`Hi John, I hope you had a wonderful weekend!

I'm Riya, working as an Account Executive with Omka Tech.

You connected with my colleague, Apoorva about the development of a professional website for
your business – XYZ Systems to increase its online presence.

Unfortunately, we couldn't proceed further with the discussion. Here I'm reaching out to discuss
your business requirements.

If you have dropped the plan or hired some other professional company, please let me know so I
can stop reaching out to you.

You can also book a slot for a quick discussion on my calendar.
I look forward to hearing from you.`);

                                        setCopiedId("email-2");
                                        setTimeout(() => setCopiedId(null), 2000);
                                    }}
                                >
                                    {copiedId === "email-2" ? "✓ Copied" : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>}
                                </button>


                                <h3 className="bottom-title">
                                    To send fresh email on someone else's lead
                                </h3>

                                <p className="bottom-text">
                                    Hi John, I hope you had a wonderful weekend! <br /><br />
                                    I'm Riya, working as an Account Executive with Omka Tech. <br /><br />
                                    You connected with my colleague, Apoorva about the development of professional Website for
                                    your business – XYZ Systems to increase it's online presence. <br /><br />
                                    Unfortunately, we couldn't proceed further with the discussion. Here I'm reaching out to you to
                                    discuss your business requirements for the same. <br /><br />
                                    Or, if you have dropped the plan or hired some other professional company, please let me know
                                    so I can stop reaching out to you and bother you. <br /><br />
                                    You can also book a slot for a quick discussion on my Calendar here –
                                    I look forward to hearing from you.
                                </p>
                            </div>

                        </div>


                        {/* <div className="info-box info-box-blue">
                            <p className="info-title">
                                Do you still need it?
                            </p>
                            <p className="info-text">
                                Please let me know. I look forward to hearing from you.
                            </p>
                        </div> */}
                    </div>
                )}

                {/* WhatsApp Follow-up Templates View */}
                {activeTab === 'whatsapp' && (
                    <div className="single-column-view">
                        <div className="warning-box">
                            <p className="warning-text">
                                ⚡ Modify templates using your understanding and client situation
                            </p>
                        </div>

                        <h2 className="page-title">
                            WhatsApp Follow up Templates (Send on 3rd day or 4th day)
                        </h2>

                        <div className="whatsapp-section">
                            <h3 className="section-title-large">
                                Day 1 or Day 2: Keep line breaks, modify the msg based on client initial reply
                            </h3>

                            <div className="two-column-grid">
                                <div className="whatsapp-card">
                                    <button
                                        onClick={() => handleCopyTemplate("Hi John, I hope my message finds you well!\nI'm Riya from Omnitech.\n\nWe received your inquiry on email about the Website Development for your business asking for our prices and portfolio.\n\nI have replied to your email with our prices and work links for you to review at info@xyz.com\n\nKindly do check if you received my email.\n\nWe can chat at your earliest convenience to discuss your website needs along with our pricing to proceed further.\n\nRegards\nRiya\nRiya@omnitech.com", 'whatsapp-1')}
                                        className="copy-btn-small whatsapp-copy"
                                        title="Copy template"
                                    >
                                        {copiedId === 'whatsapp-1' ? '✓ Copied' : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>}
                                    </button>
                                    <p className="whatsapp-text">
                                        Hi John, I hope my message finds you well! <br /> <br />
                                        I’m Riya from Omka Tech. <br /> <br />
                                        We received your inquiry on email about the Website Development for your business
                                        asking for our prices and portfolio. <br /> <br />
                                        I have replied to your email with our prices and work links for you to review at
                                        abc@xyz.com <br /> <br />
                                        Just wanted to check if you received my email. <br /> <br />
                                        We can chat at your earliest convenience to discuss your website needs along with our
                                        pricing to proceed further. <br /> <br />
                                        Awaiting your reply! <br />
                                        Regards <br />
                                        Riya <br />
                                        Riya@omkatech.com
                                    </p>
                                </div>

                                <div className="whatsapp-card">
                                    <button
                                        onClick={() => handleCopyTemplate("Hi John, I hope you are doing well!\nI'm Riya from Omnia Tech. We received your inquiry on email regarding the App Development for your business.\n\nI have replied to your email with all the required information.\n\nI just wanted to check if you received it.\n\nKindly let me know. I would be happy to set a quick call to discuss about business requirements.\n\nRegards\nRiya\nriya@omniatech.com", 'whatsapp-2')}
                                        className="copy-btn-small whatsapp-copy"
                                        title="Copy template"
                                    >
                                        {copiedId === 'whatsapp-2' ? '✓ Copied' : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>}
                                    </button>
                                    <div className="or-divider">OR</div>
                                    <p className="whatsapp-text">
                                        Hi John, I hope you are doing well! <br /> <br />
                                        I’m Riya from Omka Tech. We received your inquiry on email regarding the App
                                        Development for your business. <br /> <br />
                                        I have replied to your email with all the required information. <br /> <br />
                                        I just wanted to check in if you received it. <br /> <br />
                                        Kindly let me know, I would be happy to set a quick call to discuss about business
                                        requirements. <br /> <br />
                                        Regards <br />
                                        Riya <br />
                                        riya@omkatech.com
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="whatsapp-section">
                            <div className="day-row">
                                <div className="day-column">
                                    <h3 className="section-title-large">Day 2-3</h3>
                                    <div className="whatsapp-card">
                                        <button
                                            onClick={() => handleCopyTemplate("Hi John, Good Morning!\n\nJust checking if you were able to review my email about the development for an app for your business.\n\nPlease let me know if we can do a quick chat to discuss about your business requirements along with our process to proceed further.\n\nRegards\nRiya", 'whatsapp-3')}
                                            className="copy-btn-small whatsapp-copy"
                                            title="Copy template"
                                        >
                                            {copiedId === 'whatsapp-3' ? '✓ Copied' : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>}
                                        </button>
                                        <p className="whatsapp-text">
                                            Hi John, Good Morning! <br /> <br />
                                            Just checking if you were able to review my email about the development for an app for
                                            your business. <br /> <br />
                                            Please let me know if we can do a quick chat to discuss about your business
                                            requirements along with our process to proceed further. <br /> <br />
                                            Regards <br />
                                            Riya
                                        </p>
                                    </div>
                                </div>

                                <div className="day-column">
                                    <h3 className="section-title-large">Day 4-5</h3>
                                    <div className="whatsapp-card">
                                        <button
                                            onClick={() => handleCopyTemplate("Hi John, how are you doing?\n\nDid you get time to review my last message as a reminder to my email sent last week about the app development?\n\nDo you have time this week to discuss and proceed further?\n\nLet me know.\n\nRegards\nRiya", 'whatsapp-4')}
                                            className="copy-btn-small whatsapp-copy"
                                            title="Copy template"
                                        >
                                            {copiedId === 'whatsapp-4' ? '✓ Copied' : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>}
                                        </button>
                                        <p className="whatsapp-text">
                                            Hi John, how are you doing? <br /> <br />
                                            Did you get time to review my last message as a reminder to my email sent last week
                                            about the app development? <br /> <br />
                                            Do you have time this week to discuss and proceed further? <br /> <br />
                                            Let me know. <br /> <br />
                                            Regards <br />
                                            Riya
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="day-row">
                                <div className="day-column">
                                    <h3 className="section-title-large">Day 2-9</h3>
                                    <div className="whatsapp-card">
                                        <button
                                            onClick={() => handleCopyTemplate("Hi John, any update on my last message?\n\nI look forward to hearing from you.\n\nRegards\nRiya", 'whatsapp-5')}
                                            className="copy-btn-small whatsapp-copy"
                                            title="Copy template"
                                        >
                                            {copiedId === 'whatsapp-5' ? '✓ Copied' : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>}
                                        </button>
                                        <p className="whatsapp-text">
                                            Hi John, any update on my last message? <br /> <br />
                                            I look forward to hearing from you. <br /> <br />
                                            Regards <br />
                                            Riya
                                        </p>
                                    </div>
                                </div>

                                <div className="day-column">
                                    <h3 className="section-title-large">Day 10-15</h3>
                                    <div className="whatsapp-card">
                                        <button
                                            onClick={() => handleCopyTemplate("Hi John, it's been a while since I'm following up with you on email and messages about your inquiry for the Website.\n\nDo you still need it?", 'whatsapp-6')}
                                            className="copy-btn-small whatsapp-copy"
                                            title="Copy template"
                                        >
                                            {copiedId === 'whatsapp-6' ? '✓ Copied' : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>}
                                        </button>
                                        <p className="whatsapp-text">
                                            Hi John, it’s been a while since I’m following up with you on email and messages about
                                            your inquiry for the Website. <br /> <br />
                                            Do you still need it? <br /> <br />
                                            Please let me know, I look forward to hearing from you.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="info-box info-box-blue">
                            <p className="info-title">
                                Do you still need it?
                            </p>
                            <p className="info-text">
                                Please let me know. I look forward to hearing from you.
                            </p>
                        </div> */}
                    </div>
                )}

                {/* Initial Inquiry Templates View */}
                {activeTab === 'inquiry' && (
                    <div className="single-column-view">
                        <div className="warning-box">
                            <p className="warning-text">
                                ⚡ Modify templates using your understanding and client situation
                            </p>
                        </div>

                        <h2 className="page-title">
                            Initial Inquiry Templates (Send on 3rd day or 4th day)
                        </h2>

                        <div className="two-column-grid">
                            {initialInquiryTemplates.map((template) => (
                                <div
                                    key={template.id}
                                    className="template-card-large"
                                >
                                    <div className="template-header">
                                        <h3 className="template-title-large">
                                            {template.title}
                                        </h3>
                                        <button
                                            onClick={() => handleCopyTemplate(template.content, `inquiry-${template.id}`)}
                                            className="copy-btn-small"
                                            title="Copy template"
                                        >

                                            {copiedId === `inquiry-${template.id}` ? '✓ Copied' : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>}
                                        </button>
                                        {template && template.id === 8 && <div className="or-divider">OR</div>}
                                    </div>
                                    <p className="template-content-large">{template.inquiry}</p>
                                    <p className="template-content-large">
                                        {template.content}
                                    </p>
                                </div>
                            ))}
                        </div>

                        {/* <div className="info-box info-box-blue">
                            <p className="info-title">
                                Do you still need it?
                            </p>
                            <p className="info-text">
                                Please let me know. I look forward to hearing from you.
                            </p>
                        </div> */}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TemplateShowcase;